import { render, staticRenderFns } from "./crew-advoutstand.vue?vue&type=template&id=4375b0c6&scoped=true"
import script from "./crew-advoutstand.vue?vue&type=script&lang=js"
export * from "./crew-advoutstand.vue?vue&type=script&lang=js"
import style0 from "./crew-advoutstand.vue?vue&type=style&index=0&id=4375b0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375b0c6",
  null
  
)

export default component.exports